var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    fill: "current",
    stroke: "current",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.65 19.351h14.7v-14.701h-14.7zm6.9-1.726h-5.624v-.945h5.625zm4.125-11.3c.864.009 1.657.309 2.287.806l-.008-.006-.7 1.05c-.43-.345-.973-.566-1.567-.6h-.007c-.5 0-.8.225-.8.57 0 .4.271.555 1.319.81 1.231.345 1.951.8 1.951 1.875-.007 1.089-.89 1.968-1.98 1.968-.095 0-.189-.007-.281-.02l.011.001c-1.005-.036-1.917-.409-2.632-1.01l.007.005.779-.976c.487.445 1.132.726 1.841.75h.005c.555 0 .9-.225.9-.6 0-.346-.227-.525-1.23-.8-1.246-.33-2.04-.676-2.04-1.9v-.044c.026-1.048.881-1.887 1.932-1.887.075 0 .149.004.222.013l-.009-.001zm-8.625.12.944 3.6 1.05-3.6h1.056l1.051 3.6.929-3.6h1.471l-1.8 6.225h-1.176l-1-3.6-1.02 3.6h-1.155l-1.805-6.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24 8.13-1.919-4.755-1.201-2.875-5.58-.5-.87.84-1.11-.42-3.52 1.88-3.8-2.255-6 2.46 3.225 19.171 13.275 2.324.84-4.26.15-.091h-13.14v-15.299h15.3v14.025l4.35-2.575-2.625-4.92z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebstorm);
export default __webpack_public_path__ + "static/media/webstorm.5e6b03663faf84e343302da507177d8c.svg";
export { ForwardRef as ReactComponent };